var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CurrentLocationLink } from "../../Layout";








export const ViewDocumentLink = ({ filename, entity, children }) => {
  const location = useLocation();
  const onViewer = location.pathname.match(/entity/);
  const onRelationshipsViewer = location.pathname.match(/relationships/);
  return onViewer && !onRelationshipsViewer ? /*#__PURE__*/
  _jsx(CurrentLocationLink, {
    className: "btn btn-default",
    location: location,
    queryParams: { file: filename, page: 1 },
    type: "button" }, void 0,

  children
  ) : /*#__PURE__*/

  _jsx(Link, {
    className: "btn btn-default",
    to: `/entity/${entity.sharedId}?file=${filename}`,
    type: "button" }, void 0,

  children
  );

};